'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dMain$0024 from "./io.intela.sites.digitalinternship.-Main$.js";
var $p;
function $s_Lio_intela_sites_digitalinternship_Main__main__AT__V(args) {
  $j_io$002eintela$002esites$002edigitalinternship$002e$002dMain$0024.$m_Lio_intela_sites_digitalinternship_Main$().zQ(args);
}
export { $s_Lio_intela_sites_digitalinternship_Main__main__AT__V as $s_Lio_intela_sites_digitalinternship_Main__main__AT__V };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Main.js.map
